import * as React from 'react'
import colors, { Color } from '../../../theme/colors'

type Props = {
  width?: number,
  height?: number,
  color?: Color
}

const WalletSolidSvg = ({ width, height, color }: Props) => (
  <svg width={width} height={height} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.3 4H14.4V3C14.4 1.3 13.23 0 11.7 0H2.7C1.17 0 0 1.3 0 3V15C0 16.7 1.17 18 2.7 18H15.3C16.83 18 18 16.7 18 15V7C18 5.3 16.83 4 15.3 4ZM12.6 4H2.7C2.16 4 1.8 3.6 1.8 3C1.8 2.4 2.16 2 2.7 2H11.7C12.24 2 12.6 2.4 12.6 3V4ZM16.2 13H15.3C14.31 13 13.5 12.1 13.5 11C13.5 9.9 14.31 9 15.3 9H16.2V13Z"
      fill={color}
    />
  </svg>
)

WalletSolidSvg.defaultProps = {
  width: 18,
  height: 18,
  color: colors.Primary.GreyText
}

export default WalletSolidSvg
